// Route-aware meta robots for the SPA: only the public landing stays indexable.
const PUBLIC_PATHS = new Set(["/"]);

const INDEXABLE = "index, follow";
const PRIVATE = "noindex, nofollow";

export function isPublicPath(pathname: string, hash: string): boolean {
  if (hash?.includes("session_id=")) return false; // auth callback
  const path = pathname.length > 1 && pathname.endsWith("/") ? pathname.slice(0, -1) || "/" : pathname;
  return PUBLIC_PATHS.has(path);
}

export function applyRobotsMeta(pathname: string, hash: string) {
  const tags = Array.from(document.head.querySelectorAll<HTMLMetaElement>('meta[name="robots"]'));
  const tag = tags[0] ?? document.head.appendChild(Object.assign(document.createElement("meta"), { name: "robots" }));
  tags.slice(1).forEach((t) => t.remove());
  tag.setAttribute("content", isPublicPath(pathname, hash) ? INDEXABLE : PRIVATE);
}
